import e from"styled-components";const r=e.a.attrs((()=>({target:"_blank",rel:"noreferrer"})))`
  color: #039be5;
  text-decoration: none;
  word-break: break-all;

  &:hover {
    text-decoration: underline;
  }
`;export{r as Link};
//# sourceMappingURL=Link.js.map
